import * as _ from "lodash-es";
import { deleteKeys } from "@/utils";

export const setProfileParents = (profile) => {
  const firstParentKey =
    profile.first_parent_field !== "non_user_parent" ? "user_parent" : "non_user_parent";
  const secondParentKey =
    profile.first_parent_field === "non_user_parent" ? "user_parent" : "non_user_parent";
  return {
    ...profile,
    first_parent: profile[firstParentKey],
    second_parent: profile[secondParentKey],
  };
};

export const getUserName = (user) => {
  if (!user) {
    return "-";
  }
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  return user.first_name || user.last_name || user.email;
};

export const prepareParentForPaste = (parent) => {
  const dataForPaste = _.cloneDeep(parent);
  deleteKeys(dataForPaste, ["id", "updated_at", "health_care_card_documents", "consent"]);
  deleteKeys(dataForPaste.residency_details, [
    "id",
    "visa_documents",
    "passport_documents",
    "australian_passport_documents",
  ]);
  deleteKeys(dataForPaste.alumnus, ["id"]);
  deleteKeys(dataForPaste.residential_address, ["id", "updated_at"]);
  deleteKeys(dataForPaste.mailing_address, ["id", "updated_at"]);
  return dataForPaste;
};
